import { type InferInsertModel, type InferSelectModel, relations } from 'drizzle-orm';
import {
  boolean,
  doublePrecision,
  pgTable,
  text,
  timestamp,
  uuid,
} from 'drizzle-orm/pg-core';
import { fabricTypePrintTypes, sleeveTypeFabricTypes } from './compatibility';

export const fabricTypes = pgTable('fabric_types', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  description: text('description').notNull(),
  price: doublePrecision('price').notNull(),
  isActive: boolean('is_active').default(true),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
});

export const fabricTypesRelations = relations(fabricTypes, ({ many }) => ({
  sleeveTypeFabricTypes: many(sleeveTypeFabricTypes),
  fabricTypePrintTypes: many(fabricTypePrintTypes),
}));

export type FabricType = InferSelectModel<typeof fabricTypes>;
export type CreateFabricTypeInput = InferInsertModel<typeof fabricTypes>;
export type UpdateFabricTypeInput = Partial<CreateFabricTypeInput>;
